import { render, staticRenderFns } from "./StudentFeeDetails.vue?vue&type=template&id=13462a2f"
import script from "./StudentFeeDetails.vue?vue&type=script&lang=js"
export * from "./StudentFeeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports